import { useLogin } from '@rahtab/auth/lib/token-based-auth';
import LandingScreen from '@rahtab/system/lib/screens/LandingScreen';
import { Button, getSpacing, Text, TextInput } from '@rahtab/ui';
import { StackScreenProps } from '@react-navigation/stack';
import React, { FC, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import type { RootStackType } from '../Router';

const backgroundImage = require('assets/images/landing.png');

type LandingScreenProps = StackScreenProps<RootStackType, 'Landing'>;

const Landing: FC<LandingScreenProps> = () => {
  const { login, loginLoading } = useLogin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [selected, setSelected] = useState('');
  const handleSignIn = () => {
    login(username, password);
  };
  return (
    <LandingScreen
      transparentLoading={loginLoading}
      title="به اپلیکیشن توزیع‌کنندگان و پذیرندگان رهتاب خوش آمدید."
      backgroundImage={backgroundImage}>
      <TextInput
        label="نام کاربری"
        placeholder="نام کاربری خود را وارد نمایید."
        value={username}
        returnKeyType="next"
        textContentType="username"
        autoCompleteType="username"
        autoCapitalize="none"
        autoCorrect={false}
        onFocus={() => {
          setSelected('username');
        }}
        onChangeText={setUsername}
        onSubmitEditing={() => setSelected('password')}
      />
      <TextInput
        label="گذرواژه"
        returnKeyType="done"
        textContentType="password"
        autoCompleteType="password"
        placeholder="گذرواژه خود را وارد نمایید."
        selected={selected === 'password'}
        secureTextEntry
        autoCapitalize="none"
        value={password}
        onChangeText={setPassword}
        onSubmitEditing={handleSignIn}
      />
      <Button text="ورود" color="secondary" onPress={handleSignIn} />
      <View style={styles.notRegisteredView}>
        <Text margin="none">
          در صورت فراموشی اطلاعات کاربری, به
          <Text color="primary"> میزکار خود </Text>
          مراجعه نمایید.
        </Text>
      </View>
    </LandingScreen>
  );
};

export default Landing;

const styles = StyleSheet.create({
  notRegisteredView: {
    marginTop: getSpacing(),
    flexDirection: 'row',
    justifyContent: 'center',
  },
});
